import React from "react";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { useDocumentV1Form } from "documentV1/hooks";
import { getDocumentCoreApiExceptInvoice } from "utilities/apiUtils";
import { DocumentTypeWithoutInvoice, getDocumentRoutes } from "utilities/documentUtils";
import { getDocumentV1FormSections } from "documentV1/getDocumentV1FormSections";

interface Props {
  documentType: server.dto.DocumentType;
  artistRiders: server.dto.ArtistRider[];
}

export const DocumentV1NewEditSection = (props: Props) => {
  const hook = useDocumentV1Form({ documentType: props.documentType.value, allArtistRiders: props.artistRiders });
  const documentType = props.documentType.value as DocumentTypeWithoutInvoice;
  const submit = async () => {
    const createApi = getDocumentCoreApiExceptInvoice(documentType);

    return createApi.Create({
      addresseeCompanyId: hook.addressee!.companyId,
      bookkeepingId: hook.bookkeeping!.bookkeepingId,
      currency: hook.currency,
      dueInDays: hook.dueInDays,
      exchangeRate: hook.exchangeRate,
      sendDate: hook.sendDate.toDate(),
      ownerUserId: hook.owner.userId,
      isDraft: hook.isDraft,
      concerning: hook.concerning,
      contactId: hook.contact?.contactId,
      documentType: props.documentType.value,
      artistRiderId: hook.artistRider?.artistRiderId,
    });
  }

  const sections = getDocumentV1FormSections(hook, {
    documentType,
  });

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={(itemId) => {
      const documentRoutes = getDocumentRoutes(documentType, itemId);
      return documentRoutes.detail;
    }}
    sections={[sections]}
  />
}

export default DocumentV1NewEditSection;


